/**
  * @file
  * Attach behaviors for the Video.
  */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Video control.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.heroVideo = {

    attach: function (context) {

      const $videoContainer = $('.hero-video__container', context);
      const $video = $('.hero-video__container video', context);
      const $videoIcon = $('.hero-video__control-btn', context);
      const $scroller = $('.page__anchor-container', context);
      /**
       * Check the current playstate.
       * @return {void}.
       */
      function isPlaying() {
        if ($videoContainer.hasClass('playing')) {
          $videoContainer.removeClass('playing');
        }
        else {
          $videoContainer.addClass('playing');
        }
      }

      $scroller.on('click', function () {
        $('html,body').animate({
          scrollTop: $('.layout-content').offset().top
        }, 'slow');
      });

      // This is the actual video click.
      $video.on('click', function () {
        this.paused ? this.play() : this.pause();
        isPlaying();
      });

      // This is the icon that has spacebar control.
      $videoIcon.on('click keyup',function (e) {
        if (e.type === 'click') {
          $video[0].paused ? $video[0].play() : $video[0].pause();
          isPlaying();
        }

        else if (e.type === 'keyup') {
          if (e.keyCode === 32) {
            $video[0].paused ? $video[0].play() : $video[0].pause();
            isPlaying();
          }
        }
      });

      // Check if there is a video before force running.
      var vid = document.getElementById('video');

      window.onload = function () {
        if(vid) {
          document.querySelector('#video').play();
        }
      };
    }
  };
})(document, Drupal, jQuery);
